import { YearDropDown } from '@apply/components/';
import { usePropertyRentalYearBuilt } from '../../../../queries/PropertyFields/RentalCoreFields';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';

export interface YearBuiltRentalProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const YearBuiltRental: React.FC<YearBuiltRentalProps> = ({ propertyGuid, required, isReview = false }) => {
    const label = 'Year Built';
    const [year, set_year] = usePropertyRentalYearBuilt(propertyGuid);

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={year}
                />
            ) : (
                <YearDropDown
                    id={'yearBuiltDropDown'}
                    value={year}
                    onChange={(value) => {
                        if (value === null || value === undefined || value === '') {
                            set_year(undefined);
                        } else {
                            set_year(parseInt(value));
                        }
                    }}
                    label='Year Built'
                    yearStart={1850}
                    required={required}
                />
            )}
        </>
    );
};
